import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoProfileUserAdd = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ProfileUserAdd</title>
    <circle cx={14.376} cy={11.306} r={7.143} stroke="currentColor" strokeWidth={2} />
    <path
      d="M14.377 18.45c-4.28 0-8.076 2.18-10.433 5.538-.284.406-.241.953.1 1.313 2.674 2.82 6.317 4.555 10.332 4.555 2.678 0 5.191-.773 7.361-2.124M20.328 20.458h7.391m-3.696-3.696v7.392"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoProfileUserAdd;
